import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogRemittSsoComponent } from 'app/components/dialog-remitt-sso/dialog-remitt-sso.component';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DialogRemittSsoService {
  
  constructor(private dialog: MatDialog) { }

  openDialog(data: any): Observable<boolean> {
    const dialogRef = this.dialog.open(DialogRemittSsoComponent, {
      data: data,
    });

    return dialogRef.afterClosed();
  }
}
